import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b3ffvix4: FaireBrandEntity = {
  token: "b_b3ffvix4",
  type: "brand",
  name: "Taylor's Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/336870d12cb507587980b09edba7c72c7fde59913458402701ac9744700a35e5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/be9c3a3cb0c3797154f7316c6fa78ddfe77d27c8f58ef1a0cf5c4af36a3e23ec.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/336870d12cb507587980b09edba7c72c7fde59913458402701ac9744700a35e5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/be9c3a3cb0c3797154f7316c6fa78ddfe77d27c8f58ef1a0cf5c4af36a3e23ec.jpeg",
  location: "Scottsdale, AZ, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 113,
  isTopShop: true,
  isInsider: true,
  description:
    "Quality  – Transparency - Sustainability - Zero Waste.\n\nThat is what Taylor’s Naturals has always been about.  Born in California, raised in Hawaii and continuing to grow in Arizona.  Taylor’s Naturals has come a long way.  Starting out with a single liquid soap now with an extensive product line.  One thing that has always remained the same is our commitment to Quality and Sustainability.  As much as possible, we use Organic Locally Sourced ingredients and go the extra mile to provide product packaging with little to no plastic.  All of our products are Vegan & Cruelty-Free! (Leaping Bunny Certified)  We don't use any synthetic unhealthy binders and provide full transparency with our ingredients.  We infuse all our oils in house.  Our products are the real deal!  Pure, Natural, Healthy!\n\nWe are family owned and operated, hand-crafting all our products in small batches ensuring quality.  A portion of proceeds goes to different charitable organizations with similar values.  We feel it is important to somehow give back to Mother Earth who has given so much to us.\n\n~ From our Family to yours ♥",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:21.555Z",
    importedBy: "entity-db-cli",
  },
};
